import React from 'react';
import './itemDetail.css'

// Muestra la descripcion de un producto que elige el usuari

const ItemDetail = ({datos, onAddWish}) => {
   
    return (
        
            <div key={datos.id} className="container py-md-5">
            <div className="cuerpo-detail">
                <div className="row">
                    <div className="desc1-izq col-md-6">
                        <img src={datos.imag} className="img-fluid" alt="producto"/>
                    </div>
                    <div className="desc1-derch col-md-6 pl-lg-3">
                        <h2>{datos.title}</h2>
                        <h5>Precio: ${datos.precio}</h5>
                        <div className="disponible mt-3">
                        <button className="btn shop" onClick={()=>onAddWish()}><i className="fas fa-heart"></i></button>
                        </div>
                        <div className="buscar-desc mt-5">
                            <div className="buscar text-left">
                                <h4>Buscar Producto:</h4>
                                <div className="social-ficons mt-4">
                                    <ul>
                                        <li><a href="/"><span className="fab fa-facebook-f"></span> Facebook</a></li>
                                        <li><a href="/"><span className="fab fa-twitter"></span> Twitter</a></li>
                                        <li><a href="/"><span className="fab fa-google-plus-g"></span>Google</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
                <div className="row sub-para-w3pvt my-5">

                    <h3 className="shop-detail">{datos.description}</h3>

                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elPellentesque vehicula augue eget nisl ullamcorper, molestie blandit ipsum auctor. Mauris volutpat augue dolor.Consectetur adipisicing elit, sed do eiusmod tempor incididunt ut lab ore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco. labore et dolore magna aliqua.</p>

                    <p className="mt-3 italic-blue">Consectetur adipisicing elPellentesque vehicula augue eget nisl ullamcorper, molestie blandit ipsum auctor. Mauris volutpat augue dolor.Consectetur adipisicing elit, sed do eiusmod tempor incididunt ut lab ore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco. labore et dolore magna aliqua.</p>

                </div>
            </div>
        </div> 
    
    )
}
export default ItemDetail